import React, { useState } from "react"
import "../../assets/scss/custom.css"
import { FaBirthdayCake } from "react-icons/fa"
import { sendBirthdayWish } from "helpers/api_helper"

const UpcomingBirthdays = ({ birthdays }) => {
  const [sentMap, setSentMap] = useState({});
  const [loadingMap, setLoadingMap] = useState({});

  const handleSendWish = async (birthday) => {
    try {
      setLoadingMap(prev => ({ ...prev, [birthday._id]: true }));

      const petAge = new Date().getFullYear() - new Date(birthday.dateOfBirth).getFullYear();

      const response = await sendBirthdayWish({
        parentEmail: birthday.parentId?.email,
        parentName:  birthday.parentId?.fullName,
        petName:     birthday.fullName,
        petType:     birthday.petType || "Pet",
        petAge:      petAge,
      });

      if (response.status === 1) {
        setSentMap(prev => ({ ...prev, [birthday._id]: true }));
      }
    } catch (error) {
      console.error("Failed to send birthday wish:", error);
    } finally {
      setLoadingMap(prev => ({ ...prev, [birthday._id]: false }));
    }
  };

  return (
    <div className="upcoming-birthdays-card dashboard-card">
      <div className="upcoming-birthdays-header">
        <h5>Upcoming Birthdays</h5>
      </div>
      <div className="upcoming-birthdays-list">
        {birthdays && birthdays.length ? birthdays.map((birthday, index) => {
          let birthdayDate = new Date(birthday.dateOfBirth).setFullYear(new Date().getFullYear());
          const dob = new Date(birthday.dateOfBirth);
          const today = new Date();
          let years = today.getFullYear() - dob.getFullYear();

          return (
            <div key={index} className="birthday-item">
              <div className="birthday-info" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <FaBirthdayCake className="birthday-icon" size={24} />

                <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <h6 className="mb-0">{birthday.fullName}</h6>
                  <small className="text-muted">{birthday?.petType || ""}</small>
                  <small className="text-muted">{`${years} yrs`}</small>
                  <small className="text-muted">{new Date(birthdayDate).toLocaleDateString("in")}</small>
                </div>

                <button
                  className="send-wishes-btn"
                  style={{ marginLeft: "4px", position: "relative", opacity: sentMap[birthday._id] ? 0.7 : 1 }}
                  onClick={() => handleSendWish(birthday)}
                  disabled={sentMap[birthday._id] || loadingMap[birthday._id]}
                >
                  {loadingMap[birthday._id] ? "⏳" : sentMap[birthday._id] ? "✅" : "🎉"}
                  <span className="tooltip-wishes">
                    {loadingMap[birthday._id] ? "Sending..." : sentMap[birthday._id] ? "Wishes Sent!" : "Send Wishes"}
                  </span>
                </button>
              </div>
            </div>
          );
        }) : (
          <div className="birthday-item" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <h6>No birthday data found.</h6>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingBirthdays;